import SettingsView from '../views/Settings'

const Settings = () => {
  return <SettingsView />
}

export default Settings
